var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectTimerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#CC773A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 17.834C24.1884 17.834 17.8333 24.1892 17.8333 32.0007C17.8333 39.8122 24.1884 46.1673 31.9999 46.1673C39.8114 46.1673 46.1666 39.8122 46.1666 32.0007C46.1666 24.1892 39.8114 17.834 31.9999 17.834ZM31.9999 43.334C25.751 43.334 20.6666 38.2496 20.6666 32.0007C20.6666 25.7517 25.751 20.6673 31.9999 20.6673C38.2488 20.6673 43.3333 25.7517 43.3333 32.0007C43.3333 38.2496 38.2488 43.334 31.9999 43.334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4166 24.916H30.5833V32.5858L35.2483 37.2509L37.2515 35.2478L33.4166 31.4128V24.916Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTimerIcon);
export default __webpack_public_path__ + "static/media/Project_timer_icon.3f2f2a9c.svg";
export { ForwardRef as ReactComponent };